<template>
  <v-dialog 
  v-model="dialog" 
  :content-class="contentClass"
  scrollable 
  transition="c-anim-slide-up-fade"
  :fullscreen="$vuetify.breakpoint.xs" 
  :max-width="viewMode === 'small' ? '400px' : '900px'"
  >

  <v-card>

    <div class="toolbar-pagetop">
      <v-row class="pa-2 align-center">
        <v-btn
        icon
        @click="close">
          <v-icon color="text">arrow_back</v-icon>
        </v-btn>
        <div class="c-flex-r1 align-center text-sans font-weight-bold">
          Select build
        </div>
        <div style="width: 52px;"></div>
      </v-row>

      <v-layout 
      v-if="viewMode !== 'table'"
      class="pa-2">
        <v-text-field
        v-model="filters.search.name_inventory_item"
        solo
        placeholder="Search..."
        class="crx-box-input"
        color="text"
        hide-details
        @focus="searchMode = true"
        ref="searchBar"
        clearable
        @keydown.down.prevent="focusBelow()"
        @keydown.up.prevent="focusAbove()"
        @keydown.enter.prevent="onEnter()">

        </v-text-field>
      </v-layout>

    </div>
    
    <!-- DIALOG MAIN CONTENT -->
    <div style="overflow: auto; flex: 1;">

      <!-- secondary header (simple pagination and item count) -->
      <v-layout class="align-center border-b--thin">
        <div class="pa-4 label">
          {{ pagination.rowCount }} items
        </div>

        <v-spacer></v-spacer>

        <v-menu offset-y open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              v-on="on"
            >
              <v-icon>mdi-view-grid</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
            :class="[{'color1--text': viewMode === 'grid'}]"
            @click="setViewMode('grid')">
              <v-list-item-title
              :class="[{'color1--text': viewMode === 'grid'}]">
                Grid
              </v-list-item-title>
            </v-list-item>
            <v-list-item
            @click="setViewMode('table')">
              <v-list-item-title
              :class="[{'color1--text': viewMode === 'table'}]">
                Table
              </v-list-item-title>
            </v-list-item>
            <v-list-item
            @click="setViewMode('small')">
              <v-list-item-title
              :class="[{'color1--text': viewMode === 'small'}]">
                Small
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <div class="mr-4">

          <v-tooltip top open-delay="500">
            <template v-slot:activator="{ on }">
              <v-btn
              v-on="on"
              icon
              small
              :disabled="page <= 0"
              @click="goToPreviousPage()"
              class=""
              >
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
            </template>
            <span>Previous page</span>
          </v-tooltip>

          <v-tooltip top open-delay="500">
            <template v-slot:activator="{ on }">
              <v-btn
              v-on="on"
              icon
              small
              :disabled="page >= pagination.pages - 1"
              @click="goToNextPage()"
              class=""
              >
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </template>
            <span>Next page</span>
          </v-tooltip>

        </div>
      </v-layout>
      <!-- !secondary header (simple pagination and item count) -->

      <!-- TABLE MODE -->
      <template v-if="viewMode === 'table'">
        <table class="final-table th-no-padding full-width lines-b">
          <colgroup ref="colgroup1">
            <col width="30px">
            <col width="15px">
            <col width="15px">
            <col width="15px">
          </colgroup>

          <tr class="unselectable">

            <!--
            <th :class="['sticky', {'active-sort-column': filters.sortCol === 'name'}]">
                
              <v-layout v-ripple @click="clickSortHeader('name')" :class="['sort-button']" style="padding: 8px 12px 8px 16px;">
                Name
                <v-icon 
                small
                color="color1"
                :class="['sort-arrow', {'rotate': filters.sortCol === 'name' && filters.sortAscending}, {'visible': filters.sortCol === 'name' }]">
                  arrow_downward
                </v-icon>
              </v-layout>
              
            </th>
            -->

            <c-table-header
            title="Name"
            code="name_inventory_item"
            class="sticky"
            :filters="filters"
            @onClick="clickSortHeader">
            </c-table-header>

            <c-table-header
            title="Build name"
            code="name_build"
            :filters="filters"
            @onClick="clickSortHeader">
            </c-table-header>

            <!--
            <th :class="[{'active-sort-column': filters.sortCol === 'stock'}]">
              <v-layout v-ripple @click="clickSortHeader('stock')" :class="['sort-button']" style="padding: 8px 12px 8px 16px;">
                Stock
                <v-icon 
                small
                color="color1"
                :class="['sort-arrow', {'rotate': filters.sortCol === 'stock' && filters.sortAscending}, {'visible': filters.sortCol === 'stock' }]">
                  arrow_downward
                </v-icon>
              </v-layout>
            </th>
            -->

            <c-table-header
            title="ID"
            code="id"
            :filters="filters"
            @onClick="clickSortHeader">
            </c-table-header>

            <c-table-header
            title="Items"
            code="items"
            :filters="filters">
            </c-table-header>

          </tr>

          <tr style="">
            <td>
              <v-text-field
              v-model="filters.search.name_inventory_item"
              placeholder="Search..."
              hide-details
              class="crx-box-input"
              clearable
              color="color1"
              solo
              ref="firstTableSearchBar"
              @keydown.down.prevent="focusBelow()"
              @keydown.up.prevent="focusAbove()"
              @keydown.enter.prevent="onEnter()">
              </v-text-field>
            </td>
            <td>
              <v-text-field
              v-model="filters.search.name_build"
              placeholder="Search..."
              hide-details
              class="crx-box-input"
              clearable
              color="color1"
              solo
              @keydown.down.prevent="focusBelow()"
              @keydown.up.prevent="focusAbove()"
              @keydown.enter.prevent="onEnter()">
              </v-text-field>
            </td>
            <td>
              <v-text-field
              v-model="filters.search.id"
              placeholder="Search..."
              hide-details
              class="crx-box-input"
              clearable
              color="color1"
              solo
              @keydown.down.prevent="focusBelow()"
              @keydown.up.prevent="focusAbove()"
              @keydown.enter.prevent="onEnter()">
              </v-text-field>
            </td>
            <td>

            </td>
          </tr>

        </table>
        <table class="final-table lines-b pointer hover full-width">
          <colgroup ref="colgroup2">
            <col width="30px">
            <col width="15px">
            <col width="15px">
            <col width="15px">
          </colgroup>

          <row
          v-for="(item, i) in items" 
          :key="item.id"
          :item="item"
          :viewMode="viewMode"
          :searchFilters="filters.search"
          :active="currentIndex === i"
          :currentSelection="item.id === currentSelectedID"
          :disabled="exceptions.includes(item.id)"
          @click.native="onItemSelected(item)"
          ></row>

        </table>
      </template>
      <!-- !TABLE MODE -->
          

      <!-- LIST -->
      <v-layout wrap v-else-if="viewMode === 'grid'">
        <v-container fluid>
          <v-row dense>
            <v-col cols="12" sm="6" md="4" lg="4"
            v-for="(item, i) in items" 
            :key="item.id">
              <row
              class="align-self-stretch"
              :item="item"
              :viewMode="viewMode"
              :searchFilters="filters.search"
              :active="currentIndex === i"
              :currentSelection="item.id === currentSelectedID"
              :disabled="exceptions.includes(item.id)"
              @click.native="onItemSelected(item)"
              ></row>
            </v-col>
          </v-row>
        </v-container>
      </v-layout>
      <!-- END LIST -->

      <template v-else-if="viewMode === 'small'">
        <row
        v-for="(item, i) in items" 
        :key="item.id"
        :item="item"
        :viewMode="viewMode"
        :searchFilters="filters.search"
        :currentSelection="item.id === currentSelectedID"
        :active="currentIndex === i"
        :disabled="exceptions.includes(item.id)"
        @click.native="onItemSelected(item)"
        ></row>
      </template>

    </div><!-- END DIALOG MAIN CONTENT -->

    <!-- BOTTOM TOOLBAR -->
    <div class="border-t--thin">

      <!-- PAGINATION -->
      <v-layout align-center justify-center class="pa-2">

        <v-btn
        text
        :disabled="page <= 0"
        @click="goToFirstPage()"
        class="mr-2"
        >
          1
        </v-btn>

        <v-btn
        text
        :disabled="page <= 0"
        @click="goToPreviousPage()"
        class="mr-2"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>

        <template v-if="pagination.rowCount > 0">
          <span class="font-weight-bold">
            {{ page + 1 }}
          </span>
        </template>
        <template v-else>
          1
        </template>

        <v-btn
        :disabled="page >= pagination.pages - 1"
        text
        @click="goToNextPage()"
        class="ml-2 mr-2"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>

        <v-btn
        text
        :disabled="!(page < (pagination.pages - 1))"
        @click="goToLastPage()"
        class="mr-2"
        >
          {{ pagination.pages || 1 }}
        </v-btn>

        <v-spacer></v-spacer>

        |

        <c-s-list-items-per-page :rowsPerPage.sync="filters.rowsPerPage" class="mr-2"></c-s-list-items-per-page>

      </v-layout>
      <!-- PAGINATION -->

    </div>
    <!-- !BOTTOM TOOLBAR -->

  </v-card>

  </v-dialog>
</template>

<script>
import ServerListController from '@/mixins/ServerListController'
import ServerListBindings from '@/mixins/ServerListBindings'
import CSListItemsPerPage from '@/components/list-server/C-SListItemsPerPage'
import CTableHeader from '@/components/list-server/th'
import Row from './Row'

export default {
  mixins: [ServerListController, ServerListBindings],
  props: {
    exceptions: {
      default: () => [] // [id, id, id]
    },
    currentSelectedID: {
      default: null
    }
  },
  components: {
    Row,
    CSListItemsPerPage,
    CTableHeader
  },
  data () {
    return {
      viewMode: 'table', // grid, table, small
      dialog: false,
      resolve: null,
      reject: null,
      currentIndex: 0,
      inventory_item_id: null, // activate mode to only show builds for a certain inventory item
      filters: {
        rowsPerPage: 9,
        sortCol: 'name_inventory_item',
        sortAscending: true,
        date: {
          mainSelect: 'is equal to',
          isInTheLast_select: 'days',
          isInTheLast_input: null,
          date1: null,
          date2: null,
        },
        search: {
          id: '',
          name_inventory_item: '',
          name_build: '',
        },
        active: {
          customer: false,
          date: false
        },
        categories: []
      },
      page: 0
    }
  },
  watch: {
    items (nv) {
      if (nv.length <= this.currentIndex) {
        this.currentIndex = 0
      }
    }
  },
  computed: {
    contentClass () {
      return 'c-dialog-border-13' + (this.$vuetify.breakpoint.smAndUp ? ' dialog-height-90vh' : '')
    }
  },
  methods: {
    focusBelow () {
      if (this.currentIndex < this.items.length - 1) {
        this.currentIndex ++
      }
    },
    focusAbove () {
      if (this.currentIndex > 0) {
        this.currentIndex--
      }
    },
    onClick (item) {
      this.onItemSelected(item)
    },
    onEnter () {
      var match = this.items[this.currentIndex]
      if (match) {
        this.onClick(match)
      }
    },
    open (inventory_item_id) {
      this.inventory_item_id = inventory_item_id
      this.filters.search.name_inventory_item = ''
      this.filters.search.name_build = ''
      this.page = 0
      this.currentIndex = 0
      this.dialog = true
      this.$nextTick(() => {
        this.focusFirstTextView()
      })
      this.loadAPI()
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    focusFirstTextView () {
      if (this.viewMode === 'table') {
        this.$refs.firstTableSearchBar.focus()
      } else {
        this.$refs.searchBar.focus()
      }
    },
    setViewMode (viewMode) {
      this.viewMode = viewMode
      this.$nextTick(() => {
        this.focusFirstTextView()
      })
    },
    close () {
      this.dialog = false
      this.reject()
    },
    onItemSelected (item) {
      if (this.exceptions.includes(item.id)) {
        return
      }
      if (this.currentSelectedID === item.id) {
        return
      }
      this.resolve(item)
      this.dialog = false
    },
    loadAPI: _.debounce(function (e) {
      return new Promise((resolve, reject) => {
        const encodedFilters = btoa(JSON.stringify(this.filters))
        var inventory_item_id = this.inventory_item_id ? '&inventory_item_id=' + this.inventory_item_id : ''
        this.$axios.get(`/product-builds/?filters=${encodedFilters}&page=${this.page}${inventory_item_id}`)
          .then(response => {
            var rows = response.data.rows
            this.pagination.rowCount = response.data.count
            this.pagination.pages = Math.ceil(this.pagination.rowCount / this.filters.rowsPerPage)
            this.items = rows
            resolve(response.data)
          })
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
      })
    }, 150, {leading: true}),
  },
  created () {
    this.loadAPI()
  }
}
</script>

<style scoped lang="scss">
::v-deep .dialog-height-90vh {
  height: 90vh;
}
</style>
